import { AxiosInstance, AxiosRequestConfig } from "axios";
import { get } from "lodash";
import { Params } from "custom-types";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const selectFieldDataFetcher = (
  requestConfig: AxiosRequestConfig,
  axios: AxiosInstance,

  options?: {
    labelKey?: string | string[];
    valueKey?: string;
    valuePrefix?: string;
    valueSeparator?: string;
    includeMeta?: boolean;
    separator?: string;
  },
  omitOptions?: Array<string>,
  extraOptions?: Array<{ label: string; value: string | null }>,
) => {
  return async (inputValue: string, queryParams?: Params) => {
    const {
      valuePrefix,
      valueSeparator,
      labelKey,
      valueKey,
      includeMeta,
      separator,
    } = options || {};
    let selectOptions: Array<any> = [];
    try {
      const { data } = await axios({
        ...requestConfig,
        params: {
          ...requestConfig.params,
          ...queryParams,
          paginate: false,
        },
      });
      selectOptions = get(data, "data", []).map((item: any) => {
        if(typeof item === 'string') {
          return {
            label: item,
            value: item,
          }
        }
        const label = Array.isArray(labelKey)
          ? labelKey
              .map((key) => get(item, key, ""))
              .filter(Boolean)
              .join(separator || " - ")
          : get(item, labelKey ?? "name");

        return {
          label,
          value: valuePrefix
            ? `${get(item, valuePrefix)}${valueSeparator}${get(item, valueKey ?? "idx")}`
            : get(item, valueKey ?? "idx"),
          ...(includeMeta && { meta: item }),
        };
      });
      if (omitOptions) {
        selectOptions = selectOptions.filter(
          (option) => !omitOptions.includes(option.value),
        );
      }
      if (extraOptions) {
        selectOptions = [...selectOptions, ...extraOptions];
      }
    } catch (err) {
      selectOptions = [
        {
          label: "Couldn't fetch data",
          options: [],
        },
      ];
      console.error(err);
    }

    return selectOptions;
  };
};
